export { default } from './RibbonOne'
